
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/price-pointer",
      function () {
        return require("private-next-pages/tools/price-pointer/index.tsx");
      }
    ]);
  